export default "__VITE_ASSET__CmCMRZ5l__";